
import { defineComponent } from '@vue/composition-api';
import { FCButton } from '@fc/angie-ui';
import { FormattedProduct } from '@fc/app-common/src/services/Shopify/types';
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';
import ReviewsGrid from '~/components/storyblok/ReviewsGrid/ReviewsGrid.vue';
import PackageAboveTheFold from '~/components/v2/pdps/PackageAboveTheFold.vue';
import FaqSection from '~/components/shop/FaqSection.vue';
import storeMutations from '~/store/constants/storeMutations';
import { transformPackageProduct } from '~/utils/transformers';
import packages from '~/data/packages.js';

export default defineComponent({
  name: 'FightCampConnect',
  head: {
    ...metaData.connect,
    script: [
      {
        src: 'https://static.truemed.com/widgets/product-page-widget.min.js',
        defer: true,
      },
    ],
  },
  components: {
    PackageAboveTheFold,
    ReviewsGrid,
    FaqSection,
    FCButton,
  },
  data() {
    return {
      reviews: [],
      faqs: [],
    };
  },
  mounted() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, true);

    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  },
  destroyed() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, false);
  },
  computed: {
    packageData() {
      return transformPackageProduct({
        cmsContent: packages[0],
        eCommContent: this.$store.getters.productsCollection,
      });
    },
    pdpUpsells() {
      const glovesId = process.env.NUXT_ENV_IS_PROD === 'true' ? '8448247234796' : '4252926115929';
      const hrmId = process.env.NUXT_ENV_IS_PROD === 'true' ? '7667444646124' : '7091661111385';

      return [{
        id: `gid://shopify/Product/${glovesId}`,
        label: 'Most Popular',
      },
      {
        id: `gid://shopify/Product/${hrmId}`,
        label: 'In-app Features',
      }];
    },
    popUpUpsells() {
      // [gloves, warranty, hrm, jump rope]
      const devItems = ['gid://shopify/Product/4252926115929', 'gid://shopify/Product/7766281191513', 'gid://shopify/Product/7091661111385', 'gid://shopify/Product/7091660062809'];
      const prodItems = ['gid://shopify/Product/8448247234796', 'gid://shopify/Product/8588386140396', 'gid://shopify/Product/7667444646124', 'gid://shopify/Product/7667442450668'];
      const items = process.env.NUXT_ENV_IS_PROD === 'true' ? prodItems : devItems;

      return items.map(id => {
        const prod = this.$store.getters.productsCollection?.find((item: FormattedProduct) => item.id === id);

        return {
          ...prod,
          value: prod?.variants?.[0]?.id,
          cta: 'Add to Cart',
          isDisabled: false,
        };
      });
    },
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  async asyncData({ $storyapi, error }) {
    try {
      const storyBlok = new CMSService({ cmsService: $storyapi });
      const reviews = await storyBlok.getAll('user-reviews');

      const faqs = await storyBlok.get('global/globalpackagefaqs');
      const faqList = faqs?.data?.story?.content?.global?.[0]?.container || [];

      return {
        reviews, faqs: faqList,
      };
    } catch (e:any) {
      error({ message: e.message });
      return {};
    }
  },
});
